import s from './membership.Style';
import { styled } from 'styled-components';
import { isLogin } from '../../../utils/auth';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, NavigateOptions } from 'react-router-dom';
import { req } from '../../../@api/request';
import { premiumBenefit, standardBenefit } from './plan/data';

interface PrimiumProps {
  plans: any[];
  month: number;
  props: any;
}

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
}

// const premiumData = [
//   {
//     month: 12,
//     data: {
//       type: 'P',
//       plan_id: 10,
//       plan_name: '특별할인 상품',
//       plan_prc: 1500000,
//       is_discount: 'Y',
//       name: '바른NPL 특전 전국 12개월 프리미엄 멤버십',
//     },
//   },
// ];

const ItemBase = ({ plans, month, props }: PrimiumProps) => {
  const [selectedPlan, setSelectedPlan] = useState(plans[0]);
  const [onDrop, setOnDrop] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const defaultDiscountPlan = plans.find((plan) => plan.is_discount === 'Y');
    if (defaultDiscountPlan) setSelectedPlan(defaultDiscountPlan);
  }, [plans]);

  useEffect(() => {
    document.body.style.overflow = onDrop ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [onDrop]);

  const formattedPrice = selectedPlan?.plan_prc?.toLocaleString('ko-KR');
  const normalPrice = (selectedPlan?.plan_prc * 2).toLocaleString('ko-KR');

  const showAlert = (
    message: string,
    navigateTo: string,
    navigate: (path: string, options?: NavigateOptions) => void,
    state?: any,
  ) => {
    alert(message);
    if (state) {
      navigate(navigateTo, { state });
    } else {
      navigate(navigateTo);
    }
  };

  const naver_script = () => {
    if (window.wcs) {
      if (!window.wcs_add) window.wcs_add = {};
      window.wcs_add['wa'] = 's_2489d344048e';
      const _conv = {
        type: 'begin_checkout',
        items: [
          {
            id: selectedPlan?.plan_id,
            name: selectedPlan?.name,
            payAmount: selectedPlan?.plan_prc,
          },
        ],
      };
      window.wcs.trans(_conv);
    }
  };

  return (
    <s.Container>
      <s.Div>
        <s.Title>{props.title}</s.Title>
        {props.description}
        <s.Discount>
          <s.EarlyBird
            style={{
              visibility:
                selectedPlan?.is_discount === 'Y' ? 'visible' : 'hidden',
            }}
          >
            {selectedPlan.name.includes('바른NPL') && '바른NPL 50% 할인'}
            {selectedPlan.name.includes('얼리버드') && '얼리버드 50% 할인'}
            {selectedPlan.name.includes('공인중개사') && '공인중개사 50% 할인'}
            {!selectedPlan.name.includes('바른NPL') &&
              !selectedPlan.name.includes('얼리버드') &&
              !selectedPlan.name.includes('공인중개사') &&
              '50% 할인'}
          </s.EarlyBird>
          <s.NormalPrice
            style={{
              visibility:
                selectedPlan?.is_discount === 'Y' ? 'visible' : 'hidden',
            }}
          >
            <s style={{ fontSize: '16px', color: '#616161' }}>
              {normalPrice}원
            </s>
          </s.NormalPrice>
        </s.Discount>

        <s.Row>
          <span style={{ fontWeight: '700', fontSize: '28px' }}>
            {formattedPrice}원
          </span>
          <span style={{ position: 'relative', display: 'inline-block' }}>
            <span
              style={{
                fontWeight: '700',
                fontSize: '16px',
                color: 'rgba(55, 56, 60, 0.61)',
              }}
            >
              / {month}개월{' '}
              {selectedPlan?.is_discount === 'Y' &&
                (selectedPlan.name.includes('바른NPL') ||
                  selectedPlan.name.includes('공인중개사')) && (
                  <>
                    <span style={{ color: '#008AFF' }}>+3개월</span>
                    <TooltipBox>
                      <TooltipArrow />
                      <TooltipContent>
                        총&nbsp;
                        <span style={{ fontWeight: '700' }}>{month + 3}</span>
                        개월
                      </TooltipContent>
                    </TooltipBox>
                  </>
                )}
            </span>
          </span>
        </s.Row>

        {/* BottomSheet Trigger */}
        <Drop onDrop={onDrop} onClick={() => setOnDrop(true)}>
          <span style={{ fontWeight: '700', fontSize: '16px' }}>
            {selectedPlan?.plan_name}
          </span>
          <img
            src="/assets/images/arrow/arrow-down-gray.svg"
            alt="arrow"
            width={24}
            height={24}
          />
        </Drop>

        {/* BottomSheet UI */}
        {onDrop && (
          <BottomSheetOverlay onClick={() => setOnDrop(false)}>
            <BottomSheet onClick={(e) => e.stopPropagation()}>
              <Header>
                상품 선택
                <CloseButton
                  onClick={() => setOnDrop(false)}
                  src="/assets/images/close/close_gray_24.svg"
                />
              </Header>
              {plans.map((plan) => (
                <BottomSheetItem
                  key={plan.plan_id}
                  isDiscount={plan.is_discount === 'Y'}
                  onClick={() => {
                    setSelectedPlan(plan);
                    setOnDrop(false);
                  }}
                >
                  <BottomSheetItemText>
                    <img
                      src={
                        plan.plan_id === selectedPlan?.plan_id
                          ? '/assets/images/check/blue_check_32.svg'
                          : '/assets/images/check/gray_check_20.svg'
                      }
                      alt=""
                      style={{ width: '20px', height: '20px' }}
                    />
                    {plan.plan_name}
                  </BottomSheetItemText>
                  <BottomSheetItemText style={{ color: '#616161' }}>
                    {plan.plan_prc.toLocaleString()}원
                  </BottomSheetItemText>
                </BottomSheetItem>
              ))}
            </BottomSheet>
          </BottomSheetOverlay>
        )}

        <s.StartButton
          onClick={() => {
            const storedCode = localStorage.getItem('recommend_code');
            if (!isLogin() || storedCode !== props.recommend_code) {
              localStorage.setItem(
                'nonMemberRecommendCode',
                props.recommend_code,
              );
              showAlert(
                `구매 권한이 있는 계정으로 로그인 하거나,
추천인 코드로 회원가입 후 이용해 주세요.`,
                '/signUp',
                navigate,
                'exclusive',
              );
              return;
            }
            naver_script();
            navigate('/payment/method', { state: { selectedPlan, month } });
          }}
          disabled={selectedPlan?.is_discount !== 'Y'}
        >
          {selectedPlan?.is_discount === 'Y'
            ? '특별할인 상품 구매하기'
            : '구매하기'}
        </s.StartButton>
      </s.Div>

      <div style={{ width: '100%' }}>
        <s.BenefitList>
          {props.title === 'Standard' &&
            standardBenefit.map(({ text, number }, idx) => (
              <s.Benefit key={idx}>
                <img src="/assets/images/check/check-black.svg" alt="" />
                {text}
                <span>{number}</span>
              </s.Benefit>
            ))}
          {props.title === 'Premium' &&
            premiumBenefit.map(({ text, number }, idx) => (
              <s.Benefit key={idx}>
                <img src="/assets/images/check/check-black.svg" alt="" />
                {text}
                <span>{number}</span>
              </s.Benefit>
            ))}
        </s.BenefitList>
      </div>
    </s.Container>
  );
};

export default ItemBase;

const TooltipBox = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(6px);
  background-color: #008aff;
  border-radius: 9999px;
  padding: 2px 14px;
  color: white;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  z-index: 10;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #008aff;
`;

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  height: 20px;
`;

const Drop = styled.div<{ onDrop: boolean }>`
  padding: 14px 16px;
  border: ${({ onDrop }) =>
    onDrop ? '1px solid #008AFF' : '1px solid rgba(23, 30, 38, 0.1)'};
  border-radius: 5px;
  font-size: 14px;
  font-color: #222222;
  display: flex;
  flex-direction: row;
  position: relative;
  cursor: pointer;
  user-select: none;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8fc;
`;

const BottomSheetOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
`;

const BottomSheet = styled.div`
  width: 100%;
  max-height: 70%;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow-y: auto;
  padding: 0px 16px 40px;
`;

const BottomSheetItem = styled.div<{ isDiscount: boolean }>`
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: ${(props) => (props.isDiscount ? 'pointer' : 'default')};
  pointer-events: ${(props) => (props.isDiscount ? 'auto' : 'none')};
  opacity: ${(props) => (props.isDiscount ? '1' : '0.5')}; /* 선택 불가 표시 */

  &:hover {
    background-color: ${(props) =>
      props.isDiscount ? '#f0f0f0' : 'transparent'};
  }
`;

const BottomSheetItemText = styled.span`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1px;
`;

const Header = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 700;
  padding: 16px;
  text-align: center;
`;

const CloseButton = styled.img`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;
